<template>
  <div>
    <v-snackbar v-model="copied" color="success">
      Enlace copiado al portapapeles.
    </v-snackbar>

    <results ref="results" :results="property.usefulResults"></results>

    <v-card
      @click="redirect"
      class="d-flex align-center flex-wrap rounded-xl"
      outlined
      :ripple="false"
    >
      <v-card-text>
        <v-row align="center">
          <v-col cols="1" class="py-0 px-1">
            <v-avatar class="rounded-xl" size="75">
              <v-img
                v-if="property.images.length"
                :src="url + property.images[0].url"
              ></v-img>
              <v-img
                v-else
                :src="require('@/assets/placeholders/no-image.jpg')"
              ></v-img>
            </v-avatar>
          </v-col>
          <v-col cols="6" class="py-0 px-5">
            <div
              class="px-4 body-2 caption"
              style="width: fit-content"
              v-if="property.usefulResults"
            >
              Última actualización:
              {{ new Date(property.lastResult.createdAt).toDateString() }}
            </div>
            <v-card-title
              class="py-0 caption grey--text"
              style="text-transform:uppercase"
            >
              {{ $t("property.type." + property.propertyType.toLowerCase()) }}
            </v-card-title>
            <v-card-title class="py-0 text-subtitle-1 text-left">
              {{ property.fullAddress }}
            </v-card-title>
            <v-card-title
              v-if="property.characteristics"
              class="py-0 px-3 caption"
            >
              <span class="py-0 px-1 align-center">
                <v-icon>
                  mdi-floor-plan
                </v-icon>
                {{
                  (
                    property.characteristics.find(
                      char =>
                        char.name ==
                        $t("property.list.characteristics.environments")
                    ) || {}
                  ).value || 0
                }}
              </span>
              <span class="py-0 px-1 align-center">
                <v-icon style="margin-top: -3px">
                  mdi-bed-king-outline
                </v-icon>
                {{
                  (
                    property.characteristics.find(
                      char =>
                        char.name ==
                        $t("property.list.characteristics.bedrooms")
                    ) || {}
                  ).value || 0
                }}
              </span>
              <span class="py-0 px-1 align-center">
                <v-icon>
                  mdi-shower
                </v-icon>
                {{
                  (
                    property.characteristics.find(
                      char =>
                        char.name ==
                        $t("property.list.characteristics.bathrooms")
                    ) || {}
                  ).value || 0
                }}
              </span>
              <span class="py-0 px-1 align-center">
                <v-icon>
                  mdi-arrow-expand
                </v-icon>
                {{
                  (
                    property.characteristics.find(
                      char =>
                        char.name ==
                        $t("property.list.characteristics.total_surface")
                    ) || {}
                  ).value || 0
                }}m2
              </span>
              <span class="py-0 px-1 align-center">
                <v-icon>
                  mdi-calendar-blank
                </v-icon>
                {{
                  (
                    property.characteristics.find(
                      char =>
                        char.name ==
                        $t("property.list.characteristics.antiquity")
                    ) || {}
                  ).value || 0
                }}
              </span>
            </v-card-title>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-select
              v-model="state"
              :items="states"
              label="Estado"
              outlined
              dense
              hide-details
              class="ml-auto"
              style="max-width: 230px"
              @change="updateState"
              @click.stop=""
              v-if="result"
            ></v-select>

            <v-card-title class="py-0 text-subtitle-2" v-else>
              {{ $t("property.state." + property.state.toLowerCase()) }}
            </v-card-title>
          </v-col>

          <v-col sm="2" cols="12" class="text-center text-sm-right">
            <v-chip color="primary" small v-if="property.usefulResults">
              ¡{{ property.usefulResults.length }}
              {{
                property.usefulResults.length == 1 ? "conexión" : "conexiones"
              }}!
            </v-chip>

            <div v-if="result">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item style="cursor: pointer">
                    <v-list-item-icon>
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title @click="redirect"
                      >Ver en el panel</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item style="cursor: pointer">
                    <v-list-item-icon>
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title @click="redirectToWeb"
                      >Ver en la web</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item style="cursor: pointer">
                    <v-list-item-icon>
                      <v-icon>mdi-content-copy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title @click="copyText"
                      >Copiar enlace web</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Results from "@/components/matches/Results";

import { EditResult } from "@/graphql/mutations/results";

export default {
  data: () => ({
    copied: false,
    state: null,
    states: [
      "Pendiente",
      "Esperando respuesta",
      "Visita programada",
      "Visitada",
      "Rechazada",
      "Aprobada"
    ]
  }),

  props: {
    property: {
      required: true,
      type: Object
    },

    result: {
      required: false,
      type: Object
    },

    score: {
      required: false,
      type: String | Number
    }
  },

  computed: {
    url() {
      return "https://api.inmanager.com.ar";
    }
  },

  created() {
    if (this.result) this.state = this.result.state;
  },

  components: {
    Results
  },

  methods: {
    copyText() {
      navigator.clipboard.writeText(
        "https://sartorinmobiliaria.com/p/" + this.property.id
      );
      this.copied = true;
    },

    redirect() {
      if (this.score) {
        const routeData = this.$router.resolve({
          name: "Property",
          params: { id: this.property.id }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$refs.results.dialog = true;
      }
    },

    redirectToWeb() {
      window.open("https://sartorinmobiliaria.com/p/" + this.property.id);
    },

    updateState() {
      this.$apollo
        .mutate({
          mutation: EditResult,
          variables: {
            input: {
              id: this.result.id,
              attributes: {
                state: this.state
              }
            }
          }
        })
        .then(res => {});
    }
  }
};
</script>
